export default "__VITE_ASSET__B3MT0CIO__"